import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { PriceInsightsListItem } from "../../insights.types";
import { requestPriceInsights } from "./priceInsights.request";

const usePriceInsights = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<PriceInsightsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "with-price-insights", requestParams],
    queryFn: async () => await requestPriceInsights(requestParams),
    ...options
  });

  return { priceInsights: data?.data, meta: data?.meta, ...rest };
};

export default usePriceInsights;
